import { getFunctions, httpsCallable } from "firebase/functions";
import { REGION } from "store/ref";
import { getApp } from "firebase/app";

const app = getApp();
const functions = getFunctions(app, REGION);

// get functions api.
export const getApiFunctions = () => {
  //forward
  const forwardClient = httpsCallable(
    functions,
    "api-draft-bailiff-forwarding-client"
  ); // {id, numberOfPage} quyền reseller

  // :::::::::::: WITH SUPPORTER :::::::::::::://
  const fixSentences = httpsCallable(
    functions,
    "api-draft-dialog-reseller-fix-sentence"
  ); // { id, slot, text }  -> sửa từng câu văn.
  const passQC = httpsCallable(
    functions,
    "api-draft-dialog-reseller-pass-dialog"
  ); // { id  }  quyền reseller
  const warnQC = httpsCallable(
    functions,
    "api-draft-dialog-reseller-warn-dialog"
  ); // { id, reason } quyền reseller
  const denyQC = httpsCallable(
    functions,
    "api-draft-dialog-reseller-deny-dialog"
  ); // { id, reason } quyền reseller

  //

  // rút tiền.
  const withdrawBailiffWallet = httpsCallable(
    functions,
    "api-payment-withdraw-order-generate"
  ); // {amount, source: bailiff, accountNumber, code, accountName}

  // thêm tài khoản.
  const bankAddAccount = httpsCallable(functions, "api-bank-add-account"); // { accountName, accountNumber, code }
  // xóa tài khoản.
  const bankDeleteAccount = httpsCallable(functions, "api-bank-delete-account"); // {id}

  // return.
  return {
    reseller: {
      forwardClient,
      //
      fixSentences,
      passQC,
      denyQC,
      warnQC,
    },
    payment: {
      withdrawBailiffWallet,
    },
    bank: {
      bankAddAccount,
      bankDeleteAccount,
    },
  };
};
